import React from "react";
import { WebinarsBody } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { renderRichText } from "@/lib/richText";
import VideoPlayer from "@/components/VideoPlayer";

interface WebinarsBodyProps {
  blok?: WebinarsBody & SbBlokData;
}

const WebinarsBodyComponent: React.FC<WebinarsBodyProps> = ({ blok }) => {


  if (!blok) return null;

  const { title, subtitle, body, video_tag } = blok;

  return (
    <div {...storyblokEditable(blok)} className="container pt-5 pb-4">
      <div className="row justify-content-center gy-4 gy-md-0">
        <div className="col-md-12 col-lg-13 col-xl-14 col-xxl-16">
          {title && (<h2>{title}</h2>)}
          {subtitle && (<p className="mb-3 mb-lg-4 fw-bolder">{subtitle}</p>)}
          {body && (
            <div
              dangerouslySetInnerHTML={{ __html: renderRichText(body) }}
            />
          )}
          {video_tag && (
            <VideoPlayer videoId={video_tag} />
          )}
        </div>
      </div>
    </div>
  );
};

export default WebinarsBodyComponent;